import { getAxiosInstance } from "../../../api";

export const getDesignBankData = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/photo-uploading/design-bank/edit?design_bank_id=${id}`
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};


export const deleteDesignBank = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.delete(`/photo-uploading/design-bank/delete`, {
      data: body,
    });
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const addDesignBankData = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/photo-uploading/design-bank/save`, body);
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const editDesignBankData = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/photo-uploading/design-bank/update`,
      body
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const downloadDesignBankData = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/photo-uploading/design-bank/download?design_bank_id=${id}`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    return error.response?.data;
  }
};
